export const ipipQuestionsEN = [
	{
		question: 'Worry about things',
		code: 'i1',
		keyed: true,
		questionPosition: 1,
	},
	{
		question: 'Make friends easily',
		code: 'i2',
		keyed: true,
		questionPosition: 2,
	},
	{
		question: 'Have a vivid imagination',
		code: 'i3',
		keyed: true,
		questionPosition: 3,
	},
	{
		question: 'Trust others',
		code: 'i4',
		keyed: true,
		questionPosition: 4,
	},
	{
		question: 'Complete tasks successfully',
		code: 'i5',
		keyed: true,
		questionPosition: 5,
	},
	{
		question: 'Get angry easily',
		code: 'i6',
		keyed: true,
		questionPosition: 6,
	},
	{
		question: 'Love large parties',
		code: 'i7',
		keyed: true,
		questionPosition: 7,
	},
	{
		question: 'Believe in the importance of art',
		code: 'i8',
		keyed: true,
		questionPosition: 8,
	},
	{
		question: 'Use others for my own ends',
		code: 'i9',
		keyed: false,
		questionPosition: 9,
	},
	{
		question: 'Like to tidy up',
		code: 'i10',
		keyed: true,
		questionPosition: 10,
	},
	{
		question: 'Often feel blue',
		code: 'i11',
		keyed: true,
		questionPosition: 11,
	},
	{
		question: 'Take charge',
		code: 'i12',
		keyed: true,
		questionPosition: 12,
	},
	{
		question: 'Experience my emotions intensely',
		code: 'i13',
		keyed: true,
		questionPosition: 13,
	},
	{
		question: 'Love to help others',
		code: 'i14',
		keyed: true,
		questionPosition: 14,
	},
	{
		question: 'Keep my promises',
		code: 'i15',
		keyed: true,
		questionPosition: 15,
	},
	{
		question: 'Find it difficult to approach others',
		code: 'i16',
		keyed: true,
		questionPosition: 16,
	},
	{
		question: 'Am always busy',
		code: 'i17',
		keyed: true,
		questionPosition: 17,
	},
	{
		question: 'Prefer variety to routine',
		code: 'i18',
		keyed: true,
		questionPosition: 18,
	},
	{
		question: 'Love a good fight',
		code: 'i19',
		keyed: false,
		questionPosition: 19,
	},
	{
		question: 'Work hard',
		code: 'i20',
		keyed: true,
		questionPosition: 20,
	},
	{
		question: 'Go on binges',
		code: 'i21',
		keyed: true,
		questionPosition: 21,
	},
	{
		question: 'Love excitement',
		code: 'i22',
		keyed: true,
		questionPosition: 22,
	},
	{
		question: 'Love to read challenging material',
		code: 'i23',
		keyed: true,
		questionPosition: 23,
	},
	{
		question: 'Believe that I am better than others',
		code: 'i24',
		keyed: false,
		questionPosition: 24,
	},
	{
		question: 'Am always prepared',
		code: 'i25',
		keyed: true,
		questionPosition: 25,
	},
	{
		question: 'Panic easily',
		code: 'i26',
		keyed: true,
		questionPosition: 26,
	},
	{
		question: 'Radiate joy',
		code: 'i27',
		keyed: true,
		questionPosition: 27,
	},
	{
		question: 'Tend to vote for liberal political candidates',
		code: 'i28',
		keyed: true,
		questionPosition: 28,
	},
	{
		question: 'Sympathize with the homeless',
		code: 'i29',
		keyed: true,
		questionPosition: 29,
	},
	{
		question: 'Jump into things without thinking',
		code: 'i30',
		keyed: false,
		questionPosition: 30,
	},
	{
		question: 'Fear for the worst',
		code: 'i31',
		keyed: true,
		questionPosition: 31,
	},
	{
		question: 'Feel comfortable around people',
		code: 'i32',
		keyed: true,
		questionPosition: 32,
	},
	{
		question: 'Enjoy wild flights of fancy',
		code: 'i33',
		keyed: true,
		questionPosition: 33,
	},
	{
		question: 'Believe that others have good intentions',
		code: 'i34',
		keyed: true,
		questionPosition: 34,
	},
	{
		question: 'Excel in what I do',
		code: 'i35',
		keyed: true,
		questionPosition: 35,
	},
	{
		question: 'Get irritated easily',
		code: 'i36',
		keyed: true,
		questionPosition: 36,
	},
	{
		question: 'Talk to a lot of different people at parties',
		code: 'i37',
		keyed: true,
		questionPosition: 37,
	},
	{
		question: 'See beauty in things that others might not notice',
		code: 'i38',
		keyed: true,
		questionPosition: 38,
	},
	{
		question: 'Cheat to get ahead',
		code: 'i39',
		keyed: false,
		questionPosition: 39,
	},
	{
		question: 'Often forget to put things back in their proper place',
		code: 'i40',
		keyed: false,
		questionPosition: 40,
	},
	{
		question: 'Dislike myself',
		code: 'i41',
		keyed: true,
		questionPosition: 41,
	},
	{
		question: 'Try to lead others',
		code: 'i42',
		keyed: true,
		questionPosition: 42,
	},
	{
		question: "Feel others' emotions",
		code: 'i43',
		keyed: true,
		questionPosition: 43,
	},
	{
		question: 'Am concerned about others',
		code: 'i44',
		keyed: true,
		questionPosition: 44,
	},
	{
		question: 'Tell the truth',
		code: 'i45',
		keyed: true,
		questionPosition: 45,
	},
	{
		question: 'Am afraid to draw attention to myself',
		code: 'i46',
		keyed: true,
		questionPosition: 46,
	},
	{
		question: 'Am always on the go',
		code: 'i47',
		keyed: true,
		questionPosition: 47,
	},
	{
		question: 'Prefer to stick with things that I know',
		code: 'i48',
		keyed: false,
		questionPosition: 48,
	},
	{
		question: 'Yell at people',
		code: 'i49',
		keyed: false,
		questionPosition: 49,
	},
	{
		question: "Do more than what's expected of me",
		code: 'i50',
		keyed: true,
		questionPosition: 50,
	},
	{
		question: 'Rarely overindulge',
		code: 'i51',
		keyed: false,
		questionPosition: 51,
	},
	{
		question: 'Seek adventure',
		code: 'i52',
		keyed: true,
		questionPosition: 52,
	},
	{
		question: 'Avoid philosophical discussions',
		code: 'i53',
		keyed: false,
		questionPosition: 53,
	},
	{
		question: 'Think highly of myself',
		code: 'i54',
		keyed: false,
		questionPosition: 54,
	},
	{
		question: 'Carry out my plans',
		code: 'i55',
		keyed: true,
		questionPosition: 55,
	},
	{
		question: 'Become overwhelmed by events',
		code: 'i56',
		keyed: true,
		questionPosition: 56,
	},
	{
		question: 'Have a lot of fun',
		code: 'i57',
		keyed: true,
		questionPosition: 57,
	},
	{
		question: 'Believe that there is no absolute right and wrong',
		code: 'i58',
		keyed: true,
		questionPosition: 58,
	},
	{
		question: 'Feel sympathy for those who are worse off than myself',
		code: 'i59',
		keyed: true,
		questionPosition: 59,
	},
	{
		question: 'Make rash decisions',
		code: 'i60',
		keyed: false,
		questionPosition: 60,
	},
	{
		question: 'Am afraid of many things',
		code: 'i61',
		keyed: true,
		questionPosition: 61,
	},
	{
		question: 'Avoid contacts with others',
		code: 'i62',
		keyed: false,
		questionPosition: 62,
	},
	{
		question: 'Love to daydream',
		code: 'i63',
		keyed: true,
		questionPosition: 63,
	},
	{
		question: 'Trust what people say',
		code: 'i64',
		keyed: true,
		questionPosition: 64,
	},
	{
		question: 'Handle tasks smoothly',
		code: 'i65',
		keyed: true,
		questionPosition: 65,
	},
	{
		question: 'Lose my temper',
		code: 'i66',
		keyed: true,
		questionPosition: 66,
	},

	{
		question: 'Prefer to be alone',
		code: 'i67',
		keyed: false,
		questionPosition: 67,
	},
	{
		question: 'Do not like poetry',
		code: 'i68',
		keyed: false,
		questionPosition: 68,
	},
	{
		question: 'Take advantage of others',
		code: 'i69',
		keyed: false,
		questionPosition: 69,
	},
	{
		question: 'Leave a mess in my room',
		code: 'i70',
		keyed: false,
		questionPosition: 70,
	},
	{
		question: 'Am often down in the dumps',
		code: 'i71',
		keyed: true,
		questionPosition: 71,
	},
	{
		question: 'Take control of things',
		code: 'i72',
		keyed: true,
		questionPosition: 72,
	},
	{
		question: 'Rarely notice my emotional reactions',
		code: 'i73',
		keyed: false,
		questionPosition: 73,
	},
	{
		question: 'Am indifferent to the feelings of others',
		code: 'i74',
		keyed: false,
		questionPosition: 74,
	},
	{
		question: 'Break rules',
		code: 'i75',
		keyed: false,
		questionPosition: 75,
	},
	{
		question: 'Only feel comfortable with friends',
		code: 'i76',
		keyed: true,
		questionPosition: 76,
	},
	{
		question: 'Do a lot in my spare time',
		code: 'i77',
		keyed: true,
		questionPosition: 77,
	},
	{
		question: 'Dislike changes',
		code: 'i78',
		keyed: false,
		questionPosition: 78,
	},
	{
		question: 'Insult people',
		code: 'i79',
		keyed: false,
		questionPosition: 79,
	},
	{
		question: 'Do just enough work to get by',
		code: 'i80',
		keyed: false,
		questionPosition: 80,
	},
	{
		question: 'Easily resist temptations',
		code: 'i81',
		keyed: false,
		questionPosition: 81,
	},
	{
		question: 'Enjoy being reckless',
		code: 'i82',
		keyed: true,
		questionPosition: 82,
	},
	{
		question: 'Have difficulty understanding abstract ideas',
		code: 'i83',
		keyed: false,
		questionPosition: 83,
	},
	{
		question: 'Have a high opinion of myself',
		code: 'i84',
		keyed: false,
		questionPosition: 84,
	},
	{
		question: 'Waste my time',
		code: 'i85',
		keyed: false,
		questionPosition: 85,
	},
	{
		question: "Feel that I'm unable to deal with things",
		code: 'i86',
		keyed: true,
		questionPosition: 86,
	},
	{
		question: 'Love life',
		code: 'i87',
		keyed: true,
		questionPosition: 87,
	},
	{
		question: 'Tend to vote for conservative political candidates',
		code: 'i88',
		keyed: false,
		questionPosition: 88,
	},
	{
		question: "Am not interested in other people's problems",
		code: 'i89',
		keyed: false,
		questionPosition: 89,
	},
	{
		question: 'Rush into things',
		code: 'i90',
		keyed: false,
		questionPosition: 90,
	},
	{
		question: 'Get stressed out easily',
		code: 'i91',
		keyed: true,
		questionPosition: 91,
	},
	{
		question: 'Keep others at a distance',
		code: 'i92',
		keyed: false,
		questionPosition: 92,
	},
	{
		question: 'Like to get lost in thought',
		code: 'i93',
		keyed: true,
		questionPosition: 93,
	},
	{
		question: 'Distrust people',
		code: 'i94',
		keyed: false,
		questionPosition: 94,
	},
	{
		question: 'Know how to get things done',
		code: 'i95',
		keyed: true,
		questionPosition: 95,
	},
	{
		question: 'Am not easily annoyed',
		code: 'i96',
		keyed: false,
		questionPosition: 96,
	},

	{
		question: 'Avoid crowds',
		code: 'i97',
		keyed: false,
		questionPosition: 97,
	},
	{
		question: 'Do not enjoy going to art museums',
		code: 'i98',
		keyed: false,
		questionPosition: 98,
	},
	{
		question: "Obstruct others' plans",
		code: 'i99',
		keyed: false,
		questionPosition: 99,
	},
	{
		question: 'Leave my belongings around',
		code: 'i100',
		keyed: false,
		questionPosition: 100,
	},
	{
		question: 'Feel comfortable with myself',
		code: 'i101',
		keyed: false,
		questionPosition: 101,
	},
	{
		question: 'Wait for others to lead the way',
		code: 'i102',
		keyed: false,
		questionPosition: 102,
	},

	{
		question: "Don't understand people who get emotional",
		code: 'i103',
		keyed: false,
		questionPosition: 103,
	},
	{
		question: 'Take no time for others',
		code: 'i104',
		keyed: false,
		questionPosition: 104,
	},
	{
		question: 'Break my promises',
		code: 'i105',
		keyed: false,
		questionPosition: 105,
	},
	{
		question: 'Am not bothered by difficult social situations',
		code: 'i106',
		keyed: false,
		questionPosition: 106,
	},
	{
		question: 'Like to take it easy',
		code: 'i107',
		keyed: false,
		questionPosition: 107,
	},
	{
		question: 'Am attached to conventional ways',
		code: 'i108',
		keyed: false,
		questionPosition: 108,
	},

	{
		question: 'Get back at others',
		code: 'i109',
		keyed: false,
		questionPosition: 109,
	},
	{
		question: 'Put little time and effort into my work',
		code: 'i110',
		keyed: false,
		questionPosition: 110,
	},
	{
		question: 'Am able to control my cravings',
		code: 'i111',
		keyed: false,
		questionPosition: 111,
	},
	{
		question: 'Act wild and crazy',
		code: 'i112',
		keyed: true,
		questionPosition: 112,
	},
	{
		question: 'Am not interested in theoretical discussions',
		code: 'i113',
		keyed: false,
		questionPosition: 113,
	},
	{
		question: 'Boast about my virtues',
		code: 'i114',
		keyed: false,
		questionPosition: 114,
	},

	{
		question: 'Have difficulty starting tasks',
		code: 'i115',
		keyed: false,
		questionPosition: 115,
	},
	{
		question: 'Remain calm under pressure',
		code: 'i116',
		keyed: false,
		questionPosition: 116,
	},
	{
		question: 'Look at the bright side of life',
		code: 'i117',
		keyed: true,
		questionPosition: 117,
	},
	{
		question: 'Believe that we should be tough on crime',
		code: 'i118',
		keyed: false,
		questionPosition: 118,
	},
	{
		question: 'Try not to think about the needy',
		code: 'i119',
		keyed: false,
		questionPosition: 119,
	},
	{
		question: 'Act without thinking',
		code: 'i120',
		keyed: false,
		questionPosition: 120,
	},
]

export const ipipNeoQuestionsNL = [
	{
		question: 'Maak mij zorgen over dingen',
		code: 'i1',
		keyed: true,
		questionPosition: 1,
	},
	{
		question: 'Ik maak gemakkelijk vrienden',
		code: 'i2',
		keyed: true,
		questionPosition: 2,
	},
	{
		question: 'Heb een levendige fantasie',
		code: 'i3',
		keyed: true,
		questionPosition: 3,
	},
	{
		question: 'Vertrouw anderen',
		code: 'i4',
		keyed: true,
		questionPosition: 4,
	},
	{
		question: 'Voltooi taken succesvol',
		code: 'i5',
		keyed: true,
		questionPosition: 5,
	},
	{
		question: 'Word gemakkelijk boos',
		code: 'i6',
		keyed: true,
		questionPosition: 6,
	},

	{
		question: 'Houd van grote feesten',
		code: 'i7',
		keyed: true,
		questionPosition: 7,
	},
	{
		question: 'Geloof in het belang van kunst',
		code: 'i8',
		keyed: true,
		questionPosition: 8,
	},
	{
		question: 'Gebruik anderen voor mijn eigen doeleinden',
		code: 'i9',
		keyed: false,
		questionPosition: 9,
	},
	{
		question: 'Houd van opruimen',
		code: 'i10',
		keyed: true,
		questionPosition: 10,
	},
	{
		question: 'Voel me vaak somber',
		code: 'i11',
		keyed: true,
		questionPosition: 11,
	},
	{
		question: 'Neem de leiding',
		code: 'i12',
		keyed: true,
		questionPosition: 12,
	},

	{
		question: 'Beleef mijn emoties intens',
		code: 'i13',
		keyed: true,
		questionPosition: 13,
	},
	{
		question: 'Help anderen graag',
		code: 'i14',
		keyed: true,
		questionPosition: 14,
	},
	{
		question: 'Kom mijn beloftes na',
		code: 'i15',
		keyed: true,
		questionPosition: 15,
	},
	{
		question: 'Vind het moeilijk om anderen te benaderen',
		code: 'i16',
		keyed: true,
		questionPosition: 16,
	},
	{
		question: 'Ben altijd druk',
		code: 'i17',
		keyed: true,
		questionPosition: 17,
	},
	{
		question: 'Verkies afwisseling boven routine',
		code: 'i18',
		keyed: true,
		questionPosition: 18,
	},

	{
		question: 'Hou van een goed gevecht',
		code: 'i19',
		keyed: false,
		questionPosition: 19,
	},
	{
		question: 'Werk hard',
		code: 'i20',
		keyed: true,
		questionPosition: 20,
	},
	{
		question: 'Ik heb soms neiging om te bingen(bijv. eten, Netflix...)',
		code: 'i21',
		keyed: true,
		questionPosition: 21,
	},
	{
		question: 'Houd van spanning',
		code: 'i22',
		keyed: true,
		questionPosition: 22,
	},
	{
		question: 'Lees graag uitdagend materiaal',
		code: 'i23',
		keyed: true,
		questionPosition: 23,
	},
	{
		question: 'Geloof dat ik beter ben dan anderen',
		code: 'i24',
		keyed: false,
		questionPosition: 24,
	},

	{
		question: 'Ben altijd voorbereid',
		code: 'i25',
		keyed: true,
		questionPosition: 25,
	},
	{
		question: 'Raak gemakkelijk in paniek',
		code: 'i26',
		keyed: true,
		questionPosition: 26,
	},
	{
		question: 'Straal vreugde uit',
		code: 'i27',
		keyed: true,
		questionPosition: 27,
	},
	{
		question: 'Ben geneigd te stemmen op liberale politieke kandidaten',
		code: 'i28',
		keyed: true,
		questionPosition: 28,
	},
	{
		question: 'Voel mee met de daklozen',
		code: 'i29',
		keyed: true,
		questionPosition: 29,
	},
	{
		question: 'Spring in dingen zonder na te denken',
		code: 'i30',
		keyed: false,
		questionPosition: 30,
	},

	{
		question: 'Vrees voor het ergste',
		code: 'i31',
		keyed: true,
		questionPosition: 31,
	},
	{
		question: 'Voel mij gemakkelijk in een groep mensen',
		code: 'i32',
		keyed: true,
		questionPosition: 32,
	},
	{
		question: 'Geniet van wilde fantasieën',
		code: 'i33',
		keyed: true,
		questionPosition: 33,
	},
	{
		question: 'Geloof dat anderen goede bedoelingen hebben',
		code: 'i34',
		keyed: true,
		questionPosition: 34,
	},
	{
		question: 'Uitblinken in wat ik doe',
		code: 'i35',
		keyed: true,
		questionPosition: 35,
	},
	{
		question: 'Raak gemakkelijk geïrriteerd',
		code: 'i36',
		keyed: true,
		questionPosition: 36,
	},

	{
		question: 'Praat op feestjes met veel verschillende mensen',
		code: 'i37',
		keyed: true,
		questionPosition: 37,
	},
	{
		question: 'Ziet schoonheid in dingen die anderen misschien niet opmerken',
		code: 'i38',
		keyed: true,
		questionPosition: 38,
	},
	{
		question: 'Bedriegen om vooruit te komen',
		code: 'i39',
		keyed: false,
		questionPosition: 39,
	},
	{
		question: 'Vergeet vaak dingen op hun juiste plaats terug te zetten',
		code: 'i40',
		keyed: false,
		questionPosition: 40,
	},
	{
		question: 'Ik vind mezelf niet leuk',
		code: 'i41',
		keyed: true,
		questionPosition: 41,
	},
	{
		question: 'Probeer anderen te leiden',
		code: 'i42',
		keyed: true,
		questionPosition: 42,
	},

	{
		question: 'Voel de emoties van anderen',
		code: 'i43',
		keyed: true,
		questionPosition: 43,
	},
	{
		question: 'Ben bezorgd over anderen',
		code: 'i44',
		keyed: true,
		questionPosition: 44,
	},
	{
		question: 'Vertel de waarheid',
		code: 'i45',
		keyed: true,
		questionPosition: 45,
	},
	{
		question: 'Ben bang om de aandacht op mezelf te vestigen',
		code: 'i46',
		keyed: true,
		questionPosition: 46,
	},
	{
		question: 'Ben altijd onderweg',
		code: 'i47',
		keyed: true,
		questionPosition: 47,
	},
	{
		question: 'Blijf liever bij dingen die ik ken',
		code: 'i48',
		keyed: false,
		questionPosition: 48,
	},

	{
		question: 'Schreeuw tegen mensen',
		code: 'i49',
		keyed: false,
		questionPosition: 49,
	},
	{
		question: 'Doe meer dan wat er van me verwacht wordt',
		code: 'i50',
		keyed: true,
		questionPosition: 50,
	},
	{
		question: 'Ik ga zelden te ver in mijn verlangens',
		code: 'i51',
		keyed: false,
		questionPosition: 51,
	},
	{
		question: 'Zoek avontuur',
		code: 'i52',
		keyed: true,
		questionPosition: 52,
	},
	{
		question: 'Vermijd filosofische discussies',
		code: 'i53',
		keyed: false,
		questionPosition: 53,
	},
	{
		question: 'Denk hoog over mezelf',
		code: 'i54',
		keyed: false,
		questionPosition: 54,
	},

	{
		question: 'Voer mijn plannen uit',
		code: 'i55',
		keyed: true,
		questionPosition: 55,
	},
	{
		question: 'Word overweldigd door gebeurtenissen',
		code: 'i56',
		keyed: true,
		questionPosition: 56,
	},
	{
		question: 'Heb veel plezier',
		code: 'i57',
		keyed: true,
		questionPosition: 57,
	},
	{
		question: 'Geloof dat er geen absoluut goed of fout bestaat',
		code: 'i58',
		keyed: true,
		questionPosition: 58,
	},
	{
		question:
			'Voel sympathie voor degenen die er slechter aan toe zijn dan ikzelf',
		code: 'i59',
		keyed: true,
		questionPosition: 59,
	},
	{
		question: 'Neem overhaaste beslissingen',
		code: 'i60',
		keyed: false,
		questionPosition: 60,
	},

	{
		question: 'Ben voor veel dingen bang',
		code: 'i61',
		keyed: true,
		questionPosition: 61,
	},
	{
		question: 'Vermijd contacten met anderen',
		code: 'i62',
		keyed: false,
		questionPosition: 62,
	},
	{
		question: 'Hou van dagdromen',
		code: 'i63',
		keyed: true,
		questionPosition: 63,
	},
	{
		question: 'Vertrouw op wat mensen zeggen',
		code: 'i64',
		keyed: true,
		questionPosition: 64,
	},
	{
		question: 'Ga soepel om met taken',
		code: 'i65',
		keyed: true,
		questionPosition: 65,
	},
	{
		question: 'Verlies gemakkelijk mijn geduld',
		code: 'i66',
		keyed: true,
		questionPosition: 66,
	},

	{
		question: 'Ben liever alleen',
		code: 'i67',
		keyed: false,
		questionPosition: 67,
	},
	{
		question: 'Houd niet van poëzie',
		code: 'i68',
		keyed: false,
		questionPosition: 68,
	},
	{
		question: 'Misbruik maken van anderen',
		code: 'i69',
		keyed: false,
		questionPosition: 69,
	},
	{
		question: 'Laat een puinhoop achter in mijn kamer',
		code: 'i70',
		keyed: false,
		questionPosition: 70,
	},
	{
		question: 'Zit vaak in de put',
		code: 'i71',
		keyed: true,
		questionPosition: 71,
	},
	{
		question: 'Neem de controle over dingen',
		code: 'i72',
		keyed: true,
		questionPosition: 72,
	},

	{
		question: 'Merk zelden mijn emotionele reacties op',
		code: 'i73',
		keyed: false,
		questionPosition: 73,
	},
	{
		question: 'Ben onverschillig voor de gevoelens van anderen',
		code: 'i74',
		keyed: false,
		questionPosition: 74,
	},
	{
		question: 'Regels breken',
		code: 'i75',
		keyed: false,
		questionPosition: 75,
	},
	{
		question: 'Voel me alleen op mijn gemak bij vrienden',
		code: 'i76',
		keyed: true,
		questionPosition: 76,
	},
	{
		question: 'Doe veel in mijn vrije tijd',
		code: 'i77',
		keyed: true,
		questionPosition: 77,
	},
	{
		question: 'Houd niet van veranderingen',
		code: 'i78',
		keyed: false,
		questionPosition: 78,
	},

	{
		question: 'Beledig mensen',
		code: 'i79',
		keyed: false,
		questionPosition: 79,
	},
	{
		question: 'Doe net genoeg werk om rond te komen',
		code: 'i80',
		keyed: false,
		questionPosition: 80,
	},
	{
		question: 'Weersta gemakkelijk verleidingen',
		code: 'i81',
		keyed: false,
		questionPosition: 81,
	},
	{
		question: 'Vind het leuk om roekeloos te zijn',
		code: 'i82',
		keyed: true,
		questionPosition: 82,
	},
	{
		question: 'Heb moeite om abstracte ideeën te begrijpen',
		code: 'i83',
		keyed: false,
		questionPosition: 83,
	},
	{
		question: 'Heb een hoge dunk van mezelf',
		code: 'i84',
		keyed: false,
		questionPosition: 84,
	},

	{
		question: 'Verspil mijn tijd',
		code: 'i85',
		keyed: false,
		questionPosition: 85,
	},
	{
		question: 'Heb het gevoel dat ik dingen niet aankan',
		code: 'i86',
		keyed: true,
		questionPosition: 86,
	},
	{
		question: 'Hou van het leven',
		code: 'i87',
		keyed: true,
		questionPosition: 87,
	},
	{
		question: 'Ben geneigd te stemmen op conservatieve politieke kandidaten',
		code: 'i88',
		keyed: false,
		questionPosition: 88,
	},
	{
		question: 'Ben niet geïnteresseerd in de problemen van anderen',
		code: 'i89',
		keyed: false,
		questionPosition: 89,
	},
	{
		question: 'Overhaast dingen doen',
		code: 'i90',
		keyed: false,
		questionPosition: 90,
	},

	{
		question: 'Raak gemakkelijk gestrest',
		code: 'i91',
		keyed: true,
		questionPosition: 91,
	},
	{
		question: 'Houd anderen op een afstand',
		code: 'i92',
		keyed: false,
		questionPosition: 92,
	},
	{
		question: 'Verdwaal graag in gedachten',
		code: 'i93',
		keyed: true,
		questionPosition: 93,
	},
	{
		question: 'Mensen wantrouwen',
		code: 'i94',
		keyed: false,
		questionPosition: 94,
	},
	{
		question: 'Weet hoe ik dingen voor elkaar moet krijgen',
		code: 'i95',
		keyed: true,
		questionPosition: 95,
	},
	{
		question: 'Ben niet snel geïrriteerd',
		code: 'i96',
		keyed: false,
		questionPosition: 96,
	},

	{
		question: 'Vermijd menigten',
		code: 'i97',
		keyed: false,
		questionPosition: 97,
	},
	{
		question: 'Ga niet graag naar kunstmusea',
		code: 'i98',
		keyed: false,
		questionPosition: 98,
	},
	{
		question: 'De plannen van anderen dwarsbomen',
		code: 'i99',
		keyed: false,
		questionPosition: 99,
	},
	{
		question: 'Laat mijn spullen rondslingeren',
		code: 'i100',
		keyed: false,
		questionPosition: 100,
	},
	{
		question: 'Voel me comfortabel bij mezelf',
		code: 'i101',
		keyed: false,
		questionPosition: 101,
	},
	{
		question: 'Wacht tot anderen de weg wijzen',
		code: 'i102',
		keyed: false,
		questionPosition: 102,
	},

	{
		question: 'Begrijp mensen die emotioneel worden niet',
		code: 'i103',
		keyed: false,
		questionPosition: 103,
	},
	{
		question: 'Neem geen tijd voor anderen',
		code: 'i104',
		keyed: false,
		questionPosition: 104,
	},
	{
		question: 'Mijn beloften breken',
		code: 'i105',
		keyed: false,
		questionPosition: 105,
	},
	{
		question: 'Heb geen last van moeilijke sociale situaties',
		code: 'i106',
		keyed: false,
		questionPosition: 106,
	},
	{
		question: 'Doe het graag rustig aan',
		code: 'i107',
		keyed: false,
		questionPosition: 107,
	},
	{
		question: 'Ben gehecht aan conventionele manieren',
		code: 'i108',
		keyed: false,
		questionPosition: 108,
	},

	{
		question: 'Wraak nemen op anderen',
		code: 'i109',
		keyed: false,
		questionPosition: 109,
	},
	{
		question: 'Steek weinig tijd en moeite in mijn werk',
		code: 'i110',
		keyed: false,
		questionPosition: 110,
	},
	{
		question: 'Ben in staat mijn verlangens onder controle te houden',
		code: 'i111',
		keyed: false,
		questionPosition: 111,
	},
	{
		question: 'Doe wild en gek',
		code: 'i112',
		keyed: true,
		questionPosition: 112,
	},
	{
		question: 'Ben niet geïnteresseerd in theoretische discussies',
		code: 'i113',
		keyed: false,
		questionPosition: 113,
	},
	{
		question: 'Schep op over mijn virtues',
		code: 'i114',
		keyed: false,
		questionPosition: 114,
	},
	{
		question: 'Heb moeite om aan taken te beginnen',
		code: 'i115',
		keyed: false,
		questionPosition: 115,
	},
	{
		question: 'Blijf kalm onder druk',
		code: 'i116',
		keyed: false,
		questionPosition: 116,
	},
	{
		question: 'Bekijk het leven van de zonnige kant',
		code: 'i117',
		keyed: true,
		questionPosition: 117,
	},
	{
		question: 'Geloof dat we hard moeten optreden tegen criminaliteit',
		code: 'i118',
		keyed: false,
		questionPosition: 118,
	},
	{
		question: 'Probeer niet te denken aan mensen die het slecht hebben',
		code: 'i119',
		keyed: false,
		questionPosition: 119,
	},
	{
		question: 'Handelen zonder na te denken',
		code: 'i120',
		keyed: false,
		questionPosition: 120,
	},
]

export const ratingSystemEN = {
	1: 'Disagree strongly',
	2: 'Disagree moderately',
	3: 'Neither agree nor disagree',
	4: 'Agree a little',
	5: 'Agree strongly',
}

export const ratingSystemENSubs = {
	1: '1 out of 5',
	2: '2 out of 5',
	3: '3 out of 5',
	4: '4 out of 5',
	5: '5 out of 5',
}

export const ratingSystemNL = {
	1: 'Helemaal oneens',
	2: 'Oneens',
	3: 'Neutraal',
	4: 'Mee eens',
	5: 'Helemaal mee eens',
}

export const ratingSystemNLSubs = {
	1: '1 uit 5',
	2: '2 uit 5',
	3: '3 uit 5',
	4: '4 uit 5',
	5: '5 uit 5',
}
